import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';

/**
 * Assign Permissions to Role Use Case
 * Assigns multiple permissions to a role in batch
 */
export class AssignPermissionsToRoleUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(
        roleId: string,
        permissionNames: string[]
    ): Promise<{ message: string; assignedPermissions: string[] }> {
        return await this.roleRepository.assignPermissions(roleId, permissionNames);
    }
}
